module.exports = __webpack_public_path__ + "img/Mage-gnome-f-60.57726068.gif";